import connector from "./connector";
import auth from "./modules/auth";
import profile from "./modules/profile";
import dashboard from "./modules/dashboard";
import donations from "./modules/donations";
import payouts from "./modules/payouts";
import goals from "./modules/goals";
import settings from "./modules/settings";
import alerts from "./modules/alerts";
import exportsApi from "./modules/exports";
import payoutMethods from "./modules/payoutMethods";
import rates from "./modules/rates";
import payments from "./modules/payments";

class Repository {
  connector = connector;
  Auth = auth;
  Profile = profile;
  Dashboard = dashboard;
  Donations = donations;
  Payouts = payouts;
  Goals = goals;
  Settings = settings;
  Alerts = alerts;
  Exports = exportsApi;
  PayoutMethods = payoutMethods;
  Rates = rates;
  Payments = payments;
}

export default new Repository();
